import { graphql } from 'react-apollo';
import { compose } from 'recompose';
import {
    AddAlertMutation,
    ClearAlertsMutation,
    GetAlertsQuery,
    RemoveAlertMutation
} from '../../clientState/alerts/queries';
import {
    AlertColor,
    AlertsPayload,
    AlertsProps
} from '../../clientState/alerts/types';

const withAlertsList = graphql<any, AlertsPayload, {}, AlertsProps>(
    GetAlertsQuery,
    {
        props: ({ ownProps, data }) => ({
            ...ownProps,
            alerts: data && data.alerts ? data.alerts : []
        })
    }
);

export interface AddAlertProps {
    addAlert?: (alert: { message: string; color?: AlertColor }) => Promise<any>;
}

export const withAddAlerts = graphql<any, AlertsPayload, {}, AddAlertProps>(
    AddAlertMutation,
    {
        props: ({ ownProps, mutate }) => ({
            ...ownProps,
            addAlert: ({
                message,
                color
            }: {
                message: string;
                color?: AlertColor;
            }) => {
                return mutate
                    ? mutate({ variables: { color, message } })
                    : null;
            }
        })
    }
);

export interface RemoveAlertProps {
    removeAlert?: (alert: { message: string }) => Promise<any>;
}

export const withRemoveAlerts = graphql<
    any,
    AlertsPayload,
    {},
    RemoveAlertProps
>(RemoveAlertMutation, {
    props: ({ ownProps, mutate }) => ({
        ...ownProps,
        removeAlert: ({ message }: { message: string }) => {
            return mutate ? mutate({ variables: { message } }) : null;
        }
    })
});

interface ClearAlertsProps {
    clearAlerts(): void;
}

export const withClearAlerts = graphql<any, {}, {}, ClearAlertsProps>(
    ClearAlertsMutation,
    {
        props: ({ ownProps, mutate }) => ({
            ...ownProps,
            clearAlerts: () => (mutate ? mutate({}) : null)
        })
    }
);

export default compose<AddAlertProps & AlertsProps, any>(
    withAddAlerts,
    withRemoveAlerts,
    withAlertsList
);



// WEBPACK FOOTER //
// ./src/client/components/Alerts/withAlerts.tsx